import { render, staticRenderFns } from "./relationModel.vue?vue&type=template&id=6bc86ff4"
import script from "./relationModel.vue?vue&type=script&lang=js"
export * from "./relationModel.vue?vue&type=script&lang=js"
import style0 from "./relationModel.vue?vue&type=style&index=0&id=6bc86ff4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc86ff4')) {
      api.createRecord('6bc86ff4', component.options)
    } else {
      api.reload('6bc86ff4', component.options)
    }
    module.hot.accept("./relationModel.vue?vue&type=template&id=6bc86ff4", function () {
      api.rerender('6bc86ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/relationModel.vue"
export default component.exports